// Code values for the nav v2 flag (src/lib/navV2.ts): a storage key and a
// query parameter name. The literal guard skips *.codes.ts files by design.
export const NAV_V2_STORAGE_KEY = 'cb.navV2'
export const NAV_V2_QUERY_PARAM = 'nav_v2'
export const ARIA_CURRENT_PAGE = 'page'
export const SCAN_CTA_STORAGE_KEY = 'cb.scanCta'
export const SCAN_CTA_QUERY_PARAM = 'scan_cta'
// The floating Scan button's scroll-end clearance (ScanFab sets it on <html>
// while visible; Footer pads by it). Footprint: 4.5rem offset + 3.5rem button,
// above the safe area and the ad inset, plus 0.5rem of air.
export const FAB_CLEARANCE_VAR = '--fab-clearance'
export const FAB_CLEARANCE_VALUE = 'calc(8.5rem + env(safe-area-inset-bottom, 0px) + var(--ad-inset-bottom, 0px))'
// The collapsed Deck Chat pill's scroll-end clearance (DeckChatDock sets it on
// <html> while the pill is shown; Footer pads by it). A separate variable from
// --fab-clearance on purpose: the dock hides ScanFab, whose unmount cleanup
// removes --fab-clearance, so sharing one would race. Footprint: the pill sits
// at ScanFab's 4.5rem offset and is under 3rem tall, so ScanFab's 8.5rem fits.
export const CHAT_PILL_CLEARANCE_VAR = '--chat-pill-clearance'
export const CHAT_PILL_CLEARANCE_VALUE = FAB_CLEARANCE_VALUE
